import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Constants } from 'src/app/app.constants';

@Component({
  selector: 'engage-upgrade-dialog',
  templateUrl: './engage-upgrade-dialog.component.html',
  styleUrls: ['./engage-upgrade-dialog.component.css'],
})
export class EngageUpgradeDialogComponent {
  constructor(
    public matDialogRef: MatDialogRef<EngageUpgradeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
  ) {}

  get title(): string {
    return this.data?.title || 'Unlock more ways to engage customers';
  }

  get body(): string {
    return (
      this.data?.body ||
      'Upgrade to Growth to use this feature and create more timely customer campaigns.'
    );
  }

  get benefits(): string[] {
    return (
      this.data?.benefits || [
        'Automate customer messages and rewards',
        'Run timely campaigns without manual follow-up',
        'Use Growth tools built to increase repeat visits',
      ]
    );
  }

  seePlans(): void {
    this.matDialogRef.close();
    this.router.navigate([Constants.routes.plans]);
  }
}
